// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3KSa9","item":"PaymentsMobile_item__1q_7O","label":"PaymentsMobile_label__t6jZ0","amount":"PaymentsMobile_amount__1CVGM"};